import { render, staticRenderFns } from "./ForbiddenAccess.vue?vue&type=template&id=14fe12cd"
import script from "./ForbiddenAccess.vue?vue&type=script&lang=js"
export * from "./ForbiddenAccess.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenAccess.vue?vue&type=style&index=0&id=14fe12cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports